<template>
    <TemplateOverview
        v-if="entry && entry?.__typename === 'overview_Entry'"
        :entry
    />
    <TemplateDetail
        v-else-if="entry && entry?.__typename === 'detail_Entry'"
        :entry
    />
    <TemplateContent
        v-else-if="entry"
        :entry
    />
</template>

<script setup>
import PageQuery from '~/graphql/queries/Entry.graphql';

const { variables: defaultVariables } = useCraftGraphql();

const variables = computed(() => {
    return {
        ...defaultVariables,
        section: null
    };
});

const response = await useAsyncQuery({
    query: PageQuery,
    variables
});

const { craftEntry: entry } = useSeoCraftPage(response);

const generalStore = useGeneralStore();

generalStore.setPalette(`palette--${(entry?.value?.theme?.[0]?.slug || entry?.value?.neighbourhoodRelation?.[0]?.slug) ?? 'mma'}`);
</script>
